let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("77kvn")).then(() => parcelRequire('6z1Qp'));